<template>
  <v-container fluid>
    <template>
      <v-card>
        <v-card-title>
          <h2>
            <v-btn
              depressed
              class="mx-2"
              fab
              small
              :to="{ name: 'ordem-medicao-list', path: 'lista' }"
            >
              <v-icon>mdi-arrow-left</v-icon>
            </v-btn>
            <template>
              <span>Faturar Ordem de Medição {{ this.id }}</span>
            </template>
          </h2>
        </v-card-title>
        <form @submit.prevent="submitForm">
          <v-tabs v-model="tabs" grow>
            <v-tab>
              <v-icon
                left
                color="error"
                v-if="$v.$invalid"
                class="mdi mdi-alert-circle"
              ></v-icon>
              <span>Geral</span>
            </v-tab>
            <v-tab>
              <v-icon
                left
                color="error"
                v-if="$v.$invalid"
                class="mdi mdi-alert-circle"
              ></v-icon>
              <span>Cobrança</span>
            </v-tab>
            <v-tab>Observação</v-tab>
          </v-tabs>
          <v-tabs-items v-model="tabs">
            <v-tab-item>
              <v-card-text>
                <v-select
                  :items="empresas"
                  label="Empresa"
                  item-value="id"
                  v-model="empresaSelecionada"
                  :error-messages="empresaSelecionadaErrors"
                  :disabled="disableEmpresa"
                  required
                >
                  <template v-slot:item="{ item }">
                    <v-list-item-content>
                      <v-list-item-subtitle>{{
                        item.cnpj
                      }}</v-list-item-subtitle>
                      <v-list-item-title>{{
                        item.razao_social
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                  <template v-slot:selection="{ item }">
                    <v-list-item-content>
                      <v-list-item-subtitle>{{
                        item.cnpj
                      }}</v-list-item-subtitle>
                      <v-list-item-title>{{
                        item.razao_social
                      }}</v-list-item-title>
                    </v-list-item-content>
                  </template>
                </v-select>
                <v-text-field
                  v-model="descricao"
                  :error-messages="descricaoErrors"
                  :counter="50"
                  label="Descrição"
                  required
                  @input="$v.descricao.$touch()"
                  @blur="$v.descricao.$touch()"
                ></v-text-field>
                <v-text-field
                  v-model="nroPedido"
                  v-touch="nroPedido"
                  :counter="50"
                  maxlength="50"
                  label="Número do Pedido"
                ></v-text-field>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-row>
                  <v-col md="4">
                    <v-select
                      :items="formaPgtoContaBancaria"
                      label="Conta Bancária"
                      return-object
                      item-value="id"
                      v-model="formaPgtoContaBancariaSelecionada"
                    >
                      <template v-slot:item="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.descricao_forma_pagamento }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.descricao_conta_bancaria }}
                            <BR />
                            Ag:
                            {{ item.agencia }} CC: {{ item.conta }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                      <template v-slot:selection="{ item }">
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ item.descricao_forma_pagamento }}
                          </v-list-item-title>
                          <v-list-item-subtitle>
                            {{ item.descricao_conta_bancaria }}
                            <BR />
                            Ag:
                            {{ item.agencia }} CC: {{ item.conta }}
                          </v-list-item-subtitle>
                        </v-list-item-content>
                      </template>
                    </v-select>
                  </v-col>
                  <v-col md="3">
                    <v-menu
                      v-model="menuDataParcela"
                      :close-on-content-click="false"
                      :nudge-right="40"
                      transition="scale-transition"
                      offset-y
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dataParcela"
                          label="Data Vencimento"
                          prepend-icon="mdi mdi-calendar"
                          readonly
                          v-on="on"
                          clearable
                        ></v-text-field>
                      </template>
                      <button-datepicker
                        v-model="data_parcela"
                        @input="menuDataParcela = false"
                      />
                    </v-menu>
                  </v-col>
                  <v-col md="3">
                    <v-text-field
                      v-model="valorParcela"
                      v-mask="'money'"
                      :error-messages="valorParcelaErrors"
                      :maxlength="13"
                      label="Valor Parcela"
                      @input="$v.valorParcela.$touch()"
                      @blur="$v.valorParcela.$touch()"
                    ></v-text-field>
                  </v-col>
                  <v-col mb="2">
                    <v-btn color="primary" dark @click="addParcela()">
                      <v-icon>mdi-plus-box-multiple</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col md="4">
                    <v-card class="mx-auto" :color="corResumoParcelas" tile dark>
                      <v-list three-line :color="corResumoParcelas" dark>
                        <v-list-item-group color="primary">
                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                >Valor Total da Fatura</v-list-item-title
                              >
                              <v-list-item-subtitle>
                                R$
                                {{ number_format(this.valorFatura) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title
                                >Soma das Parcelas</v-list-item-title
                              >
                              <v-list-item-subtitle>
                                R$
                                {{ number_format(this.somaParcelas) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>

                          <v-list-item>
                            <v-list-item-content>
                              <v-list-item-title>
                                {{ rotuloSaldoParcelas }}
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                R$ {{ number_format(Math.abs(saldoParcelas)) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                  <v-col md="8">
                    <v-card class="mx-auto" width="500" tile>
                      <v-list three-line>
                        <v-subheader>Parcelas da Fatura</v-subheader>

                        <v-list-item-group v-model="parcelas" color="primary">
                          <v-list-item
                            v-for="(parcelas, i) in dadosParcela"
                            :key="i"
                          >
                            <v-list-item-avatar>{{ i + 1 }}</v-list-item-avatar>
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="parcelas.forma_pagamento"
                              ></v-list-item-title>
                              <v-list-item-subtitle
                                v-html="parcelas.banco"
                              ></v-list-item-subtitle>
                              <v-list-item-subtitle
                                v-html="parcelas.dados"
                              ></v-list-item-subtitle>
                              <v-list-item-subtitle
                                v-if="parcelas.forma_pagamento == 'BOLETO'"
                              >
                                <v-file-input
                                  show-size
                                  clearable
                                  v-model="boletos[i]"
                                  label="Arquivo do Boleto"
                                  persistent-hint
                                  accept=".pdf"
                                  prepend-icon="mdi-file-pdf-outline"
                                />
                              </v-list-item-subtitle>
                            </v-list-item-content>
                            <v-list-item-icon>
                              <v-icon
                                @click="deleteParcela(i, parcelas.valorParcela)"
                                >mdi-delete-circle-outline</v-icon
                              >
                            </v-list-item-icon>
                          </v-list-item>
                        </v-list-item-group>
                      </v-list>
                    </v-card>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-tab-item>
            <v-tab-item>
              <v-card-text>
                <v-textarea
                  v-model="observacao"
                  solo
                  name="input-7-10"
                  label="Observação"
                  height="300"
                ></v-textarea>
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
          <v-card-actions>
            <v-btn
              depressed
              color="primary"
              @click="submit"
              :loading="loading"
              :disabled="!parcelasValidas"
              >Salvar</v-btn
            >
          </v-card-actions>
        </form>
      </v-card>
    </template>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, maxLength } from "vuelidate/lib/validators";
import ButtonDatepicker from "../components/ButtonDatepicker";
import { mapState } from "vuex";
import number_format_lib from "../lib/number_format";
import { unmaskDecimal } from "../lib/masks";
import { arredondarMoeda, paraCentavos, somarMoeda } from "../lib/moeda";

export default {
  mixins: [validationMixin],
  components: { ButtonDatepicker },
  validations: {
    descricao: { required, maxLength: maxLength(50) },
    empresaSelecionada: { required },
    valorParcela: { maxLength: maxLength(13) }
  },

  data() {
    return {
      id: "",
      id_fatura: "",
      id_empresa: "",
      id_cliente: "",
      empresaSelecionada: null,
      formaPgtoContaBancariaSelecionada: null,
      descricao: "Locação de guindaste",
      observacao: "",
      nroPedido: "",
      valorParcela: "",
      valorFatura: 0,
      tabs: null,
      loading: false,
      disableEmpresa: false,
      formaPgtoContaBancaria: [],
      boletos: [],

      menuDataParcela: false,
      data_parcela: "",
      parcelas: "",
      dadosParcela: [],

      valores: "",
      dadosValores: [],

      desconto: 0,

      somaParcelas: 0,
      totalComissao: 0
    };
  },

  computed: {
    ...mapState({
      usuarioAtivo: state => state.usuarios.usuarioAtivo,
      empresaAtiva: state => state.usuarios.empresaAtiva,
      empresas: state => state.usuarios.usuarioAtivo.empresas
    }),
    descricaoErrors() {
      const errors = [];
      if (!this.$v.descricao.$dirty) return errors;
      !this.$v.descricao.required &&
        errors.push("Local de Referência é Obrigatório.");
      !this.$v.descricao.maxLength && errors.push("Somente 100 caracteres.");

      return errors;
    },
    valorParcelaErrors() {
      const errors = [];
      if (!this.$v.valorParcela.$dirty) return errors;
      !this.$v.valorParcela.maxLength && errors.push("Somente 10 caracteres.");

      return errors;
    },
    empresaSelecionadaErrors() {
      const errors = [];
      if (!this.$v.empresaSelecionada.$dirty) return errors;
      !this.$v.empresaSelecionada.required &&
        errors.push("Empresa é Obrigatório.");

      return errors;
    },
    dataParcela() {
      return this.data_parcela
        .split("-")
        .reverse()
        .join("/");
    },
    saldoParcelas() {
      const totalFatura = this.valorEmCentavos(this.valorFatura);
      const totalParcelas = this.valorEmCentavos(this.somaParcelas);

      return (totalFatura - totalParcelas) / 100;
    },
    parcelasValidas() {
      return this.saldoParcelas === 0;
    },
    corResumoParcelas() {
      if (this.parcelasValidas) {
        return "success";
      }

      return this.saldoParcelas > 0 ? "warning" : "error";
    },
    rotuloSaldoParcelas() {
      if (this.parcelasValidas) return "Total atendido";

      return this.saldoParcelas > 0 ? "Valor restante" : "Valor excedente";
    }
  },
  watch: {
    async empresaSelecionada() {
      // CARREGAR DADOS DE FORMA PGTO + CONTA BANCARIA
      try {
        this.formaPgtoContaBancaria = [];
        const dados = await this.$store.dispatch("contaBancaria/retornaDados", {
          CarregarTudo: true,
          filtros: {
            id_empresa: parseInt(this.empresaSelecionada)
          }
        });

        for (let item of dados) {
          for (let itemPgto of item.formas_pagamento) {
            const info = {
              id: item.id + "||" + itemPgto.id,
              id_conta_bancaria: item.id,
              descricao_conta_bancaria: item.descricao,
              agencia: item.agencia,
              conta: item.conta,

              id_forma_pagamento: itemPgto.id,
              descricao_forma_pagamento: itemPgto.descricao
            };
            this.formaPgtoContaBancaria.push(info);
          }
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$store.commit("ui/setSnackbar", {
          text:
            "Não foi possível carregar do dados Forma Pagamento e Conta Bancária"
        });
      }
      // =======================================
    }
  },
  methods: {
    valorEmCentavos(valor) {
      return paraCentavos(valor);
    },
    async submit() {
      if (!this.parcelasValidas) {
        this.$store.commit("ui/setSnackbar", {
          text:
            "A soma das parcelas deve ser exatamente igual ao valor total da fatura"
        });
        return;
      }

      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loading = true;
        try {
          const retorno = await this.$store.dispatch(
            "ordemMedicao/gravarFatura",
            {
              id_fatura: this.id_fatura,
              id_empresa: parseInt(this.empresaSelecionada),
              id_ordem: parseInt(this.id),
              data_emissao: new Date(),
              descricao: this.descricao,
              valor: parseFloat(this.valorFatura),
              id_usuario: this.$store.state.usuarios.usuarioAtivo.id,
              observacao: this.observacao,
              numero_pedido: this.nroPedido
            }
          );
          retorno;
          // gravar parcelas da fatura, contas receber

          if (this.dadosParcela.length > 0) {
            const letras = [
              "A",
              "B",
              "C",
              "D",
              "E",
              "F",
              "G",
              "H",
              "I",
              "J",
              "K",
              "L",
              "M",
              "N",
              "O"
            ];

            // deletar parcelas (conta receber)
            await this.$store.dispatch(
              "contasReceber/deletarPorFatura",
              parseInt(retorno.id)
            );

            //deletar comissoes
            await this.$store.dispatch(
              "contasPagar/deletarPorFatura",
              parseInt(retorno.id)
            );

            // inserir parcelas (conta receber)
            let cont = 0;
            for (let parcela of this.dadosParcela) {
              const payload = {
                id: "",
                id_empresa: this.empresaSelecionada,
                documento: retorno.numero + "/" + letras[cont],
                id_cliente: parseInt(this.id_cliente),
                data_emissao: new Date(),
                data_vencimento: parcela.dataParcela + "T00:00:00Z",
                valor_receber: parseFloat(parcela.valorParcela),
                id_forma_pagamento: parseInt(parcela.id_forma_pagamento),
                id_conta_bancaria: parseInt(parcela.id_conta_bancaria),
                origem: "FAT",
                id_origem: parseInt(retorno.id),
                situacao: "DG"
              };
              const dadosCR = await this.$store.dispatch(
                "contasReceber/gravar",
                payload
              );
              const pct = payload.valor_receber / this.valorFatura;
              const parcelaComissao = arredondarMoeda(
                this.totalComissao * pct
              );
              await this.$store.dispatch("contasPagar/gravar", {
                id: "",
                id_empresa: payload.id_empresa,
                documento: payload.documento,
                id_fornecedor: 0,
                data_emissao: payload.data_emissao,
                data_vencimento: payload.data_vencimento,
                valor_pagar: parcelaComissao,
                valor_desconto: 0,
                valor_multa: 0,
                valor_juros: 0,
                id_condicaopagamento: 1,
                origem: payload.origem,
                id_origem: payload.id_origem
              });

              var arquivoBoleto = "";
              if (parcela.forma_pagamento == "BOLETO")
                if (typeof this.boletos[cont] != "undefined") {
                  arquivoBoleto = this.boletos[cont];

                  const dados = new FormData();
                  dados.append("id", dadosCR.id);
                  dados.append("arquivo", arquivoBoleto);
                  await this.$store.dispatch(
                    "contasReceber/gravarBoleto",
                    dados
                  );
                }

              cont++;
            }
          }

          await this.$store.dispatch("ordemMedicao/gravar", {
            id: this.id,
            situacao: "H",

            id_usuario_pre_fatura: this.$store.state.usuarios.usuarioAtivo.id,
            data_hora_pre_fatura: new Date()
          });

          this.$router.replace({ path: "lista", name: "ordem-medicao-list" });
        } catch (err) {
          console.log(err);
          this.loading = false;
          this.$store.commit("ui/setSnackbar", {
            text: "Não foi possível salvar a Fatura"
          });
        }
      }
    },
    number_format(val) {
      return number_format_lib(val);
    },
    addParcela() {
      if (this.formaPgtoContaBancariaSelecionada === null) {
        this.$store.commit("ui/setSnackbar", {
          text: "Forma de Pagamento Inválida"
        });
        return false;
      }
      if (this.data_parcela == "") {
        this.$store.commit("ui/setSnackbar", {
          text: "Data Vencimento Inválida"
        });
        return false;
      }
      if (this.valorParcela == "") {
        this.$store.commit("ui/setSnackbar", {
          text: "valor Parcela Inválido"
        });
        return false;
      }

      const pagamento = this.formaPgtoContaBancariaSelecionada;
      const id_forma_pagamento = pagamento.id_forma_pagamento;
      const id_conta_bancaria = pagamento.id_conta_bancaria;
      const descricao_conta_bancaria = pagamento.descricao_conta_bancaria;
      const agencia = pagamento.agencia;
      const conta = pagamento.conta;
      const descricao_forma_pagamento = pagamento.descricao_forma_pagamento;
      const dataParcela = this.data_parcela;
      const valorParcela = unmaskDecimal(this.valorParcela);

      if (parseFloat(valorParcela) === 0) {
        return;
      }

      this.somaParcelas = somarMoeda(this.somaParcelas, valorParcela);

      const info = {
        id_forma_pagamento: id_forma_pagamento,
        id_conta_bancaria: id_conta_bancaria,
        dataParcela: dataParcela,
        valorParcela: valorParcela,
        forma_pagamento: descricao_forma_pagamento,
        banco: descricao_conta_bancaria + " Ag " + agencia + " CC " + conta,
        dados:
          "Vencimento " +
          this.DataBR(dataParcela) +
          " R$ " +
          this.number_format(valorParcela)
      };

      this.dadosParcela.push(info);
      this.dadosParcela.sort(function(a, b) {
        return new Date(a.dataParcela) - new Date(b.dataParcela);
      });

      this.formaPgtoContaBancariaSelecionada = null;
      this.data_parcela = "";
      this.valorParcela = "";
    },
    deleteParcela(val, valorParcela) {
      this.somaParcelas = somarMoeda(this.somaParcelas, -valorParcela);

      this.dadosParcela.splice(val, 1);
    },
    querySelections(v) {
      this.loading = true;
      v;
      setTimeout(() => {
        this.loading = false;
      }, 500);
    },
    formatDate(date) {
      if (!date) return null;

      const [year, month, day] = date.split("-");
      return `${day}/${month}/${year}`;
    },
    parseDate(date) {
      if (!date) return null;

      const [day, month, year] = date.split("/");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    DataSql(dataBR) {
      if (!dataBR) return null;

      const [day, month, year] = dataBR.split("/");
      return `${year}-${month}-${day}T00:00:00Z`;
    },
    DataBR(dataSql) {
      if (!dataSql) return null;

      const [year, month, day] = dataSql.split("-");
      return `${day}/${month}/${year}`;
    }
  },
  async mounted() {
    //this.preloader = true;
    this.id = "";
    if (this.$route.params.id) {
      this.id = this.$route.params.id;

      let faturamentoParcial = false;
      let percentFatura = "";
      try {
        var response = await this.$store.dispatch(
          "ordemMedicao/carregarOrdemMedicao",
          this.id
        );
        //console.log(response);
        this.id_cliente = response.data.id_cliente;
        this.desconto = response.data.desconto;

        if (
          response.data.faturamento_antecipado ||
          response.data.sinistro ||
          response.data.seguro ||
          response.data.cadastro_antecipado
        ) {
          this.empresaSelecionada = 4;
          this.disableEmpresa = true;
        }

        if (response.data.forma_faturamento == "P") {
          faturamentoParcial = true;
          percentFatura = response.data.percentual_fatura;
        }

        this.dataVencimento = this.DataBR(
          response.data.data_vencimento_programada.substr(0, 10)
        );
        this.dateVencimento = response.data.data_vencimento_programada.substr(
          0,
          10
        );

        //this.preloader = false;
      } catch (err) {
        //deu pau
      }

      const ordemItens = await this.$store.dispatch(
        "ordemMedicao/carregarItens",
        this.id
      );
      for (let item of ordemItens.data) {
        if (item.horas_cobrar == null) item.horas_cobrar = 1;

        let descontoItem = 0;
        if (item.desconto_item != null) descontoItem = item.desconto_item;

        let bv = 0;
        if (item.tem_bonificacao) {
          bv = item.valor_bonificacao * item.horas_cobrar - item.desconto_bv;
          if (item.tipo_bonificacao == "P") {
            bv =
              item.valor_cobrar *
                item.horas_cobrar *
                (item.valor_bonificacao / 100) -
              item.desconto_bv;
          }
        }
        bv = arredondarMoeda(bv);
        const valorReceber = somarMoeda(
          arredondarMoeda(item.horas_cobrar * item.valor_cobrar),
          -descontoItem
        );

        this.totalComissao = somarMoeda(
          this.totalComissao,
          arredondarMoeda(
            (valorReceber - bv) * (response.data.percentual_comissao / 100)
          )
        );

        this.valorFatura = somarMoeda(this.valorFatura, valorReceber);
      }

      //faturamento parcial
      if (faturamentoParcial) {
        this.valorFatura = arredondarMoeda(
          this.valorFatura * (percentFatura / 100)
        );
        this.totalComissao = arredondarMoeda(
          this.totalComissao * (percentFatura / 100)
        );

        if (this.desconto != null && this.desconto > 0) {
          const descontoParcial = arredondarMoeda(
            this.desconto * (percentFatura / 100)
          );
          this.valorFatura = somarMoeda(this.valorFatura, -descontoParcial);
          this.totalComissao = somarMoeda(
            this.totalComissao,
            -arredondarMoeda(
              (descontoParcial * response.data.percentual_comissao) / 100
            )
          );
        }
      } else {
        this.valorFatura = somarMoeda(this.valorFatura, -this.desconto);
        this.totalComissao = somarMoeda(
          this.totalComissao,
          -arredondarMoeda(
            (this.desconto * response.data.percentual_comissao) / 100
          )
        );
      }

      try {
        const response = await this.$store.dispatch(
          "ordemMedicao/buscarFaturaPorOrdem",
          {
            filtros: { id_ordem: parseInt(this.id) }
          }
        );

        if (response.data.length > 0) {
          const fatura = response.data.pop();
          this.id_fatura = fatura.id;
          this.empresaSelecionada = fatura.id_empresa;
          this.dataVencimento = fatura.id_empresa;
          this.descricao = fatura.descricao;
          this.nroPedido = fatura.numero_pedido;
          this.observacao = fatura.observacao;

          try {
            const contasReceber = await this.$store.dispatch(
              "contasReceber/listar",
              {
                filtros: { id_origem: parseInt(this.id_fatura), origem: "FAT" }
              }
            );

            for (let parcela of contasReceber.data.dados) {
              const id_forma_pagamento = parcela.id_forma_pagamento;
              const id_conta_bancaria = parcela.id_conta_bancaria;
              const descricao_conta_bancaria = parcela.conta_bancaria.descricao;
              const agencia = parcela.conta_bancaria.agencia;
              const conta = parcela.conta_bancaria.conta;
              const descricao_forma_pagamento =
                parcela.forma_pagamento.descricao;
              const dataParcela = parcela.data_vencimento.substr(0, 10);
              const valorParcela = parcela.valor_receber;

              this.somaParcelas = somarMoeda(
                this.somaParcelas,
                valorParcela
              );

              const info = {
                id_forma_pagamento: id_forma_pagamento,
                id_conta_bancaria: id_conta_bancaria,
                dataParcela: dataParcela,
                valorParcela: valorParcela,
                forma_pagamento: descricao_forma_pagamento,
                banco:
                  descricao_conta_bancaria + " Ag " + agencia + " CC " + conta,
                dados:
                  "Vencimento " +
                  this.DataBR(dataParcela) +
                  " R$ " +
                  this.number_format(valorParcela)
              };

              this.dadosParcela.push(info);
            }
          } catch (err) {
            console.log(err);
            this.loading = false;
            this.$store.commit("ui/setSnackbar", {
              text: "Não foi possível carregar do dados de cobrança"
            });
          }
        }
      } catch (err) {
        console.log(err);
        this.loading = false;
        this.$store.commit("ui/setSnackbar", {
          text: "Não foi possível carregar do dados da fatura"
        });
      }
    }
  }
};
</script>
